export const BLOG_BLOCK_TYPES = {
  TEXT_BLOCK: 'TextBlock',
  VIDEO_BLOCK: 'VideoBlock',
  PRODUCTS_BLOCK: 'ProductsBlock',
  IMAGE_BLOCK: 'ImageBlock'
} as const;
